import React, { useEffect } from 'react'
import i18next from 'i18next'
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar'
import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'

import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';
import Button from 'react-bootstrap-button-loader';
import styles from '../../../styles/profile.module.css';

import RoomIcon from '@material-ui/icons/Room';
import AssignmentIcon from '@material-ui/icons/Assignment';
import LocalHospitalIcon from '@material-ui/icons/LocalHospital';

import PendingAddress from './address/PendingAddress'
import AdditionalInfoForm from './additionalInfo/AdditionalInfoForm'
import MedicalForm from './medical/MedicalForm'

import * as storage from '../../../utils/storage'
import { withNamespaces } from 'react-i18next';

function a11yProps(index) {
    return {
        id: `full-width-tab-${index}`,
        'aria-controls': `full-width-tabpanel-${index}`,
    };
}

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        width: '100%',
        backgroundColor: theme.palette.background.paper,
    },
}));

function TabProfile(props) {
    const classes = useStyles();
    const [value, setValue] = React.useState(0);
    const [index, setIndex] = React.useState(0);
    const [oldIndex, setOldIndex] = React.useState(0);
    const [tempIndex, setTempIndex] = React.useState(0);
    const [flagMedical, setFlagMedical] = React.useState(storage.getDisplayMedicalData());
    const [openWarning, setOpenWarning] = React.useState(false);
    const [isDataChanged, setIsDataChanged] = React.useState(false);

    useEffect(() => {
        if (tempIndex >= 0) {
            setOldIndex(index);
            validateDataChanged((idx) => setIndex(idx));
        }
    }, [tempIndex]);

    const handlePanelAddressClick = () => {
        setTempIndex(0);
    }

    const handlePanelAdditionalClick = () => {
        setTempIndex(1);
    }

    const handlePanelMedicalClick = () => {
        setTempIndex(2);
    }

    const handleDataChanged = (isChanged) => {
        setIsDataChanged(isChanged);
    }

    const handleWarning = (isContinue) => {
        setOpenWarning(false);

        setTempIndex(-1);
        setIndex(isContinue == true ? tempIndex : oldIndex);
        setValue(isContinue == true ? tempIndex : oldIndex);

        if (isContinue) {
            setIsDataChanged(false);
        }
    }

    const validateDataChanged = (func) => {
        if (isDataChanged) {
            setOpenWarning(true);
            return;
        }

        setValue(tempIndex);
        func(tempIndex);
    }

    return (
        <React.Fragment>
            <div className={classes.root + " rootProfile"}>
                <AppBar position="static" color="default">
                    <Tabs
                        value={value}
                        variant="standard"
                        indicatorColor="primary"
                        textColor="primary"
                        className={"TabPage"}
                    >
                        <Tab className={"TabPageButton"} label={i18next.t("profile:tabPanel.address")} {...a11yProps(0)} onClick={handlePanelAddressClick} />
                        <Tab className={"TabPageButton"} label={i18next.t("profile:tabPanel.additionalInformation")} {...a11yProps(1)} onClick={handlePanelAdditionalClick} />
                        {flagMedical && <Tab className={"TabPageButton"} label={i18next.t("profile:tabPanel.medical")} {...a11yProps(2)} onClick={handlePanelMedicalClick} />}
                    </Tabs>
                </AppBar>
            </div>
            {index == 0 && <PendingAddress isPending={props.isPending} data={props.data} handleReload={props.handleReload} />}
            {index == 1 && <AdditionalInfoForm data={props.dataEmployee} handleDataChanged={handleDataChanged} handleReload={props.handleReload} />}
            {flagMedical && index == 2 && <MedicalForm data={props.dataEmployee} handleDataChanged={handleDataChanged} />}

            <Dialog
                open={openWarning}
                aria-labelledby="draggable-dialog-title"
            >
                <DialogTitle id="draggable-dialog-title">
                    {i18next.t('profile:message.warning')}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        {i18next.t('profile:address.message.confirmExit')}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button autoFocus onClick={() => handleWarning(true)} color="primary" className={styles.buttonYesNo} variant="success">
                        {i18next.t('buttons:yes')}
                    </Button>
                    <Button onClick={() => handleWarning(false)} color="primary" className={styles.buttonYesNo} variant="success">
                        {i18next.t('buttons:no')}
                    </Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
}

export default withNamespaces(['profile', 'buttons'], { wait: true })(TabProfile);